// Technikai location takarítási állapota a legutóbbi takarítás és a következő
// cleaning group határidő alapján. Az idősávot harmadokra osztja:
//   1. harmad: frissen tiszta (türkiz), fokozatosan fehérre halványul
//   2. harmad: fehér (nincs színezés)
//   3. harmad: fehérből piszkosodó színre vált, a határidőre éri el teljesen
//   határidő után: határidőn túl (piros)
// Határidő vagy takarítás nélkül nincs állapot.

export const CLEANING_STATE_COLORS = {
  clean: { fill: "#baf6ea", stroke: "#30baae" },
  soiling: { fill: "#dec6b4", stroke: "#8b5a2b" },
  overdue: { fill: "#fcb4ae", stroke: "#f63630" },
};

// A kitöltés legfeljebb ennyire fedi el az alaprajzot, hogy a vonalak látszanak.
const MAX_FILL_OPACITY = 0.5;

export function cleaningStateStyle(cleanedAt, deadlineAt, now = Date.now()) {
  if (!cleanedAt || !deadlineAt) return null;
  const start = new Date(cleanedAt).getTime();
  const end = new Date(deadlineAt).getTime();
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return null;

  if (now >= end) {
    return { state: "overdue", ...CLEANING_STATE_COLORS.overdue, opacity: 1 };
  }
  const progress = Math.max(0, (now - start) / (end - start));
  if (progress < 1 / 3) {
    return { state: "clean", ...CLEANING_STATE_COLORS.clean, opacity: 1 - progress * 3 };
  }
  if (progress < 2 / 3) return null;
  return { state: "soiling", ...CLEANING_STATE_COLORS.soiling, opacity: (progress - 2 / 3) * 3 };
}

export function cleaningStateFillOpacity(style) {
  return style ? style.opacity * MAX_FILL_OPACITY : 0;
}
